import { Navigate, useParams } from 'react-router-dom';

import { ProjectDetailsPage } from './ProjectDetailsPage';

import { areaHref, detailsHref, projectBasePath } from '@/components/project';
import { PROJECT_SETTINGS_FLAG, useFeatureFlagStatus } from '@/featureFlags';

/**
 * The Project details route's gate, behind `project-settings` (the flag the
 * Settings tab had; it carries over). Off sends the visitor to the project's
 * Planning, so a typed or shared URL reveals nothing with the flag off.
 * Nothing renders while the flag is still `pending`: redirecting then would
 * bounce a deep link on an environment where the flag turns out to be on.
 */
export const ProjectDetailsRoute = () => {
  const status = useFeatureFlagStatus(PROJECT_SETTINGS_FLAG);
  const base = projectBasePath(useParams<{ projectId?: string }>());

  if (status === 'pending') return null;
  if (status === 'off' || base === null) {
    return <Navigate to={base === null ? '/' : areaHref(base, 'planning')} replace />;
  }
  return <ProjectDetailsPage />;
};

/**
 * The Settings tab's old address. Settings became Project details, so a
 * bookmarked `/settings` lands on the new page — which applies the flag.
 */
export const SettingsRedirect = () => {
  const base = projectBasePath(useParams<{ projectId?: string }>());
  return <Navigate to={base === null ? '/' : detailsHref(base)} replace />;
};
